import produce from 'immer';
import { DialoutState } from '@zoom/videosdk';

const statusDescription: any = {
  [DialoutState.Calling]: { text: 'Calling', type: 'pending' },
  [DialoutState.Ringing]: { text: 'Ringing', type: 'pending' },
  [DialoutState.Accepted]: { text: 'Accepted', type: 'pending' },
  [DialoutState.Canceling]: { text: 'Cencelling', type: 'pending' },
  [DialoutState.Busy]: { text: 'Busy', type: 'fail' },
  [DialoutState.Fail]: { text: 'Fail', type: 'fail' },
  [DialoutState.CancelFailed]: { text: 'Cancel failed', type: 'fail' },
  [DialoutState.NotAvailable]: { text: 'NotAvailable', type: 'fail' },
  [DialoutState.Success]: { text: 'Success', type: 'success' },
  [DialoutState.Canceled]: { text: 'Canceled', type: 'success' },
};
export const getPhoneCallStatusDescription = (status?: DialoutState) => {
  if (status !== undefined) {
    return statusDescription[status];
  }
  return undefined;
};

export const mediaShape = {
  audio: {
    encode: false,
    decode: false,
  },
  video: {
    encode: false,
    decode: false,
  },
  share: {
    encode: false,
    decode: false,
  },
};

export const mediaReducer = produce((draft, action) => {
  switch (action.type) {
    case 'audio-encode': {
      draft.audio.encode = action.payload;
      break;
    }
    case 'audio-decode': {
      draft.audio.decode = action.payload;
      break;
    }
    case 'video-encode': {
      draft.video.encode = action.payload;
      break;
    }
    case 'video-decode': {
      draft.video.decode = action.payload;
      break;
    }
    case 'share-encode': {
      draft.share.encode = action.payload;
      break;
    }
    case 'share-decode': {
      draft.share.decode = action.payload;
      break;
    }
    case 'reset-media': {
      Object.assign(draft, { ...mediaShape });
      break;
    }
    default:
      break;
  }
}, mediaShape);

export const VIDEO_DATA = {
  startVideo: 'Start video',
  stopVideo: 'Stop video',
  selectCamera: 'Select a Camera',
  mirrorMyVideo: 'Mirror My Video',
  blurMyBackground: 'Blur My Background',
} as const;

export const AUDIO_DATA = {
  join: 'Join audio',
  mute: 'Mute audio',
  unmute: 'Unmute audio',
  selectMicrophone: 'Select a Microphone',
  selectSpeaker: 'Select a speaker',
  hangUp: 'Hang Up',
  leaveAudio: 'Leave Audio',
  InviteByPhone: 'Invite by phone',
} as const;

export const TIMER_DATA = {
  timeRemaining: 'Time remaining',
} as const;

export const LEAVE_BUTTON = {
  endDebate: 'End debate',
  exit: 'Exit',
} as const;
